module.exports = __webpack_public_path__ + "img/p1.89e87e8a.png";